/* eslint-disable */
/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
(function ($) {
  $.fn.scrollbox = function (config) {
    const defConfig = {
      linear: false,
      startDelay: 2,
      delay: 3,
      step: 5,
      speed: 32,
      switchItems: 1,
      direction: 'vertical',
      distance: 'auto',
      autoPlay: true,
      onMouseOverPause: true,
      paused: false,
      queue: null,
      listElement: 'ul',
      listItemElement: 'li',
      infiniteLoop: true,
      switchAmount: 0,
      afterForward: null,
      afterBackward: null,
      triggerStackable: false,
    };
    config = $.extend(defConfig, config);
    config.scrollOffset = config.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
    if (config.queue) {
      config.queue = $(`#${config.queue}`);
    }
    return this.each(function () {
      const container = $(this);
      let containerUL;
      let scrollingId = null;
      let nextScrollId = null;
      let paused = false;
      let releaseStack;
      let backward;
      let forward;
      let resetClock;
      let scrollForward;
      let scrollBackward;
      let forwardHover;
      let pauseHover;
      let switchCount = 0;
      let stackedTriggerIndex = 0;
      if (config.onMouseOverPause) {
        container.bind('mouseover', function () {
          paused = true;
        });
        container.bind('mouseout', function () {
          paused = false;
        });
      }
      containerUL = container.children(`${config.listElement}:first-child`);
      if (config.infiniteLoop === false && config.switchAmount === 0) {
        config.switchAmount = containerUL.children().length;
      }
      scrollForward = function () {
        if (paused) {
          return;
        }
        let curLi;
        let i;
        let newScrollOffset;
        let scrollDistance;
        let theStep;
        curLi = containerUL.children(`${config.listItemElement}:first-child`);
        scrollDistance =
          config.distance !== 'auto'
            ? config.distance
            : config.direction === 'vertical'
            ? curLi.outerHeight(true)
            : curLi.outerWidth(true);
        if (!config.linear) {
          theStep = Math.max(
            3,
            parseInt((scrollDistance - container[0][config.scrollOffset]) * 0.3, 10)
          );
          newScrollOffset = Math.min(container[0][config.scrollOffset] + theStep, scrollDistance);
        } else {
          newScrollOffset = Math.min(
            container[0][config.scrollOffset] + config.step,
            scrollDistance
          );
        }
        container[0][config.scrollOffset] = newScrollOffset;
        if (newScrollOffset >= scrollDistance) {
          for (i = 0; i < config.switchItems; i++) {
            if (config.queue && config.queue.find(config.listItemElement).length > 0) {
              containerUL.append(config.queue.find(config.listItemElement)[0]);
              containerUL.children(`${config.listItemElement}:first-child`).remove();
            } else {
              containerUL.append(containerUL.children(`${config.listItemElement}:first-child`));
            }
            ++switchCount;
          }
          container[0][config.scrollOffset] = 0;
          clearInterval(scrollingId);
          scrollingId = null;
          if ($.isFunction(config.afterForward)) {
            config.afterForward.call(container, {
              switchCount,
              currentFirstChild: containerUL.children(`${config.listItemElement}:first-child`),
            });
          }
          if (config.triggerStackable && stackedTriggerIndex !== 0) {
            releaseStack();
            return;
          }
          if (config.infiniteLoop === false && switchCount >= config.switchAmount) {
            return;
          }
          if (config.autoPlay) {
            nextScrollId = setTimeout(forward, config.delay * 1e3);
          }
        }
      };
      scrollBackward = function () {
        if (paused) {
          return;
        }
        let curLi;
        let i;
        let newScrollOffset;
        let scrollDistance;
        let theStep;
        if (container[0][config.scrollOffset] === 0) {
          for (i = 0; i < config.switchItems; i++) {
            containerUL
              .children(`${config.listItemElement}:last-child`)
              .insertBefore(containerUL.children(`${config.listItemElement}:first-child`));
          }
          curLi = containerUL.children(`${config.listItemElement}:first-child`);
          scrollDistance =
            config.distance !== 'auto'
              ? config.distance
              : config.direction === 'vertical'
              ? curLi.height()
              : curLi.width();
          container[0][config.scrollOffset] = scrollDistance;
        }
        if (!config.linear) {
          theStep = Math.max(3, parseInt(container[0][config.scrollOffset] * 0.3, 10));
          newScrollOffset = Math.max(container[0][config.scrollOffset] - theStep, 0);
        } else {
          newScrollOffset = Math.max(container[0][config.scrollOffset] - config.step, 0);
        }
        container[0][config.scrollOffset] = newScrollOffset;
        if (newScrollOffset === 0) {
          --switchCount;
          clearInterval(scrollingId);
          scrollingId = null;
          if ($.isFunction(config.afterBackward)) {
            config.afterBackward.call(container, {
              switchCount,
              currentFirstChild: containerUL.children(`${config.listItemElement}:first-child`),
            });
          }
          if (config.triggerStackable && stackedTriggerIndex !== 0) {
            releaseStack();
            return;
          }
          if (config.autoPlay) {
            nextScrollId = setTimeout(forward, config.delay * 1e3);
          }
        }
      };
      releaseStack = function () {
        if (stackedTriggerIndex === 0) {
          return;
        }
        if (stackedTriggerIndex > 0) {
          stackedTriggerIndex--;
          nextScrollId = setTimeout(forward, 0);
        } else {
          stackedTriggerIndex++;
          nextScrollId = setTimeout(backward, 0);
        }
      };
      forward = function () {
        clearInterval(scrollingId);
        scrollingId = setInterval(scrollForward, config.speed);
      };
      backward = function () {
        clearInterval(scrollingId);
        scrollingId = setInterval(scrollBackward, config.speed);
      };
      forwardHover = function () {
        config.autoPlay = true;
        paused = false;
        clearInterval(scrollingId);
        scrollingId = setInterval(scrollForward, config.speed);
      };
      pauseHover = function () {
        paused = true;
      };
      resetClock = function (delay) {
        config.delay = delay || config.delay;
        clearTimeout(nextScrollId);
        if (config.autoPlay) {
          nextScrollId = setTimeout(forward, config.delay * 1e3);
        }
      };
      if (config.autoPlay) {
        nextScrollId = setTimeout(forward, config.startDelay * 1e3);
      }
      container.bind('resetClock', function (delay) {
        resetClock(delay);
      });
      container.bind('forward', function () {
        if (config.triggerStackable) {
          if (scrollingId !== null) {
            stackedTriggerIndex++;
          } else {
            forward();
          }
        } else {
          clearTimeout(nextScrollId);
          forward();
        }
      });
      container.bind('backward', function () {
        if (config.triggerStackable) {
          if (scrollingId !== null) {
            stackedTriggerIndex--;
          } else {
            backward();
          }
        } else {
          clearTimeout(nextScrollId);
          backward();
        }
      });
      container.bind('pauseHover', function () {
        pauseHover();
      });
      container.bind('forwardHover', function () {
        forwardHover();
      });
      container.bind('speedUp', function (event, speed) {
        if (speed === 'undefined') {
          speed = Math.max(1, parseInt(config.speed / 2, 10));
        }
        config.speed = speed;
      });
      container.bind('speedDown', function (event, speed) {
        if (speed === 'undefined') {
          speed = config.speed * 2;
        }
        config.speed = speed;
      });
      container.bind('updateConfig', function (event, options) {
        config = $.extend(config, options);
      });
    });
  };
})(jQuery);
